import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "@/src/auth/auth-provider";

/**
 * 로그인 필요한 화면의 문지기(예전 proxy.ts의 비로그인 리다이렉트 자리). 세션을 읽는 중에는
 * 아무것도 그리지 않고 기다린다 — 그때 리다이렉트하면 로그인돼 있어도 로그인 화면으로 튕긴다.
 * 이건 화면을 가리는 용도일 뿐 보안 경계가 아니다: 진짜 접근 통제는 Supabase RLS와 API의 토큰 검증이다.
 */
export function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!user) return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}
